import styled from "styled-components";

export type InputFieldProps = { $hasDropdown?: boolean };
export const InputField = styled.input<InputFieldProps>`
  border-radius: ${({ $hasDropdown }) =>
    $hasDropdown ? "6px 6px 0 0" : "6px"};
  width: 180px;
  font-size: 16px;
  font-family: "Vy Sans";
  border-color: ${({ theme }) => theme.colorTextMain};
  border-width: 1px;
  border-style: solid;
  height: 38px;
  color: ${({ theme }) => theme.colorTextMain};
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  text-indent: 10px;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colorTextMain};
    opacity: 1;
  }
`;
